export interface UtmLeadParameters {
  source: string;
  target: string;
  widgetType: string;
}

export const utmLeadParameters = (
  url: string,
  { source, target, widgetType }: UtmLeadParameters,
) => {
  return `${url}?utm_source=${source}&utm_medium=${target}&utm_campaign=${widgetType}`;
};
